<template>
  <div id="config-color">
    <base-header class="bg-primary pb-6 pt-0">
      <div class="row align-items-center pb-2">
        <div class="col-lg-6 col-7">
          <breadcrumb
            :link="[{ name: 'Quản lý Màu sắc', active: true }]"
          ></breadcrumb>
        </div>
      </div>
    </base-header>
    <div class="container-fluid mt--6 bg-lighter">
      <block :nobody="true" ref="buser" class="soft-control">
        <control-panel
          :countChecked="countChecked"
          @doAddNew="handleCreate"
          @doEdit="handleUpdate"
          @search="handleSearch"
          @copy="handleCopy"
          :help="handleHelp"
          @doDelete="handleDelete"
        ></control-panel>
        <div class="row p-1">
          <div class="col-md-12">
            <soft-table
              @rowSelected="tbSetRowSelected"
              @rowClicked="tbRowClicked"
              class="table align-items-center table-flush"
              tbody-classes="list"
              :pending="false"
              :dataTable="tableData"
              :fields="fields"
              :showAll="true"
              :minHeight="$hControl"
              :contextMenus="[
                {
                  key: 'verify',
                  icon: 'fa-users-cog',
                  label: 'Item menu context'
                }
              ]"
              @contextMenuItemClick="tbHandleContextMenuItemClick"
              ref="soft-table"
            >
              <template v-slot:cell(userCreate)="{ value }">
                <span v-if="value.id" class="badge badge-primary">{{
                  value.username
                }}</span>
              </template>
              <template v-slot:cell(userVerify)="{ value }">
                <span v-if="value.id" class="badge badge-success">{{
                  value.username
                }}</span>
                <span v-else class="badge badge-danger">
                  Chưa được duyệt
                </span>
              </template>
              <template v-slot:cell(userManage)="{ value }">
                <span v-if="value.id" class="badge badge-info">{{
                  value.username
                }}</span>
                <span v-else class="badge badge-danger">
                  Chưa có người hỗ trợ
                </span>
              </template>
              <template v-slot:cell(color)="{ value }">
                <div
                  style="display:block; border: 1px solid #034c34; color: #cacaca; padding: 7px 25px; text-transform: uppercase;"
                  :style="`background:${value}`"
                >
                  {{ value }}
                </div>
              </template>
              <template>
                <pagination
                  class="mr-2 my-1"
                  slot="footer"
                  :total="listQuery.total"
                  :perPage="listQuery.limit"
                  @change="pagChange"
                />
              </template>
            </soft-table>
          </div>
        </div>
      </block>
    </div>
    <color-modal @submit:success="fetchData" ref="colorModal"></color-modal>
  </div>
</template>
<script>
import { colorService } from "@/_services";
import ColorModal from "./__ColorModal";

export default {
  name: "color",
  components: {
    ColorModal
  },
  data() {
    return {
      countChecked: 0,
      listQuery: {
        page: 1,
        limit: 30,
        total: 0
      },
      lastIndexCustomerSelected: 0,
      info: {},
      tableData: [],
      fields: [
        {
          variant: "primary",
          key: "id",
          class: "col-fix checkbox"
        },
        {
          key: "key",
          label: "Khóa",
          sortable: true,
          class: "col-fix"
        },
        {
          key: "label",
          label: "Tên màu sắc",
          sortable: true
        },
        {
          key: "color",
          label: "Màu sắc",
          sortable: true
        }
      ]
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      colorService.findAll(this.listQuery).then(res => {
        this.tableData = res.data;
        this.listQuery.total = res.data.length;
        this.$refs["soft-table"].selectRow(this.lastIndexCustomerSelected);
      });
    },
    pagChange(page) {
      this.listQuery.page = page;
      this.fetchData();
    },
    handleSearch(keyword) {
      this.listQuery.search = keyword;
      this.fetchData();
    },
    tbRowClicked(item, index) {
      this.info = item;
      this.lastIndexCustomerSelected = index;
    },
    tbHandleContextMenuItemClick(a) {
      console.log("context menu", a);
    },
    handleUpdate() {
      this.$refs.colorModal.visible = true;
      this.$refs.colorModal.setData(this.info);
    },
    handleCreate() {
      this.$refs.colorModal.visible = true;
      this.$refs.colorModal.setData(false);
    },
    handleCopy() {},
    handleHelp() {
      alert("help");
    },
    tbSetRowSelected(items) {
      this.customerSelecteds = items;
      this.countChecked = items.length;
    }
  }
};
</script>
<style lang="scss"></style>
